<!--
Author: TangChen
Date: 2018-10-23
Desc: 现金宝资产组件，由index.js 配置引入
-->
<template>
    <div :class="'bizcomp-currency-assets bizcomp ' + className">
        <comp-title :title="title">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/home' }">我的资产</el-breadcrumb-item>
                <el-breadcrumb-item>{{ title }}</el-breadcrumb-item>
            </el-breadcrumb>
        </comp-title>
        <el-row class="cur-info-box">
            <el-col :span="18" class="assets-con">
                <el-col :span="9" class="cur-all">
                    <span class="icon-img" />
                    <div class="icon-info">
                        <span class="amount all">{{ $util.fmtNum(xjbInfo.totalasset) }}</span>
                        <span class="amount-info">现金宝总额(元)</span>
                    </div>
                </el-col>
                <el-col :span="7">
                    <span class="icon-img yes" />
                    <div class="icon-info">
                        <span
                            class="amount"
                            :class="
                                xjbInfo.lastincome > 0
                                    ? 'add'
                                    : xjbInfo.lastincome < 0
                                    ? 'reduce'
                                    : ''
                            "
                        >
                            {{ $util.fmtNum(xjbInfo.lastincome) }}
                        </span>
                        <span class="amount-info">昨日收益(元)</span>
                    </div>
                </el-col>
                <el-col :span="8">
                    <span class="icon-img all" />
                    <div class="icon-info">
                        <span
                            class="amount"
                            :class="
                                xjbInfo.totalincome > 0
                                    ? 'add'
                                    : xjbInfo.totalincome < 0
                                    ? 'reduce'
                                    : ''
                            "
                        >
                            {{ $util.fmtNum(xjbInfo.totalincome) }}
                        </span>
                        <span class="amount-info">累计收益(元)</span>
                    </div>
                </el-col>
                <el-col :span="24">
                    <el-col :span="6" class="assets-val">
                        <div class="assets-col">
                            <i class="fa fa-jpy" aria-hidden="true" />
                            <div class="assets-text">
                                可用金额(元)：
                                <span>{{ $util.fmtNum(xjbInfo.availablevol) }}</span>
                            </div>
                        </div>
                    </el-col>
                    <el-col :span="10" class="icon-info per">
                        <div class="amount-info">
                            万份收益({{ $util.fmtDate(xjbInfo.navdate) }})：
                            <span class="amount">
                                {{ $util.fmtNum(xjbInfo.fundincomeunit, 4) }}
                            </span>
                            元
                        </div>
                        <div class="amount-info">
                            七日年化：
                            <span class="amount add">
                                {{ formatCurrencyAnnualRate(xjbInfo.growthrate) }}
                            </span>
                        </div>
                    </el-col>
                    <el-col :span="8" class="cur-btn-group other-btn">
                        <el-button
                            type="text"
                            :class="{ 'is-disabled': $util.isPersonalBuyBusinessDisabled() }"
                            v-on:click="goPersonalBuyBusiness('fund', '认申购')"
                        >
                            <i class="xjb-icon buy" aria-hidden="true" />
                            现金宝买基金
                        </el-button>
                        <el-button
                            type="text"
                            v-on:click.once="$router.push({ name: 'traderecord' })"
                        >
                            <i class="xjb-icon records" aria-hidden="true" />
                            交易记录
                        </el-button>
                    </el-col>
                </el-col>
            </el-col>
            <el-col :span="6" class="others">
                <div class="cur-btn-group btn-xjb">
                    <div>
                        <el-button
                            type="yellow"
                            :class="{ 'is-disabled': $util.isPersonalBuyBusinessDisabled() }"
                            v-on:click="goPersonalBuyBusiness('currencycharge', '充值')"
                        >
                            <i class="xjb-icon charge" aria-hidden="true" />
                            充值
                            <strong>(1元起购，0费率)</strong>
                            <i class="el-icon-arrow-right el-icon--right" aria-hidden="true" />
                        </el-button>
                    </div>
                    <div>
                        <el-button
                            type="red"
                            :disabled="!canRedemption"
                            v-on:click.once="$router.push({ name: 'currencyredemption' })"
                        >
                            <i class="xjb-icon redemption" aria-hidden="true" />
                            取现
                            <strong>(快速取现，2小时到账)</strong>
                            <i class="el-icon-arrow-right el-icon--right" aria-hidden="true" />
                        </el-button>
                    </div>
                    <div>
                        <el-button
                            type="blue"
                            :class="{ 'is-disabled': $util.isPersonalBuyBusinessDisabled() }"
                            v-on:click="goPersonalBuyBusiness('gfund', '定投')"
                        >
                            <i class="xjb-icon general" aria-hidden="true" />
                            定投
                            <i class="el-icon-arrow-right el-icon--right" aria-hidden="true" />
                        </el-button>
                    </div>
                </div>
            </el-col>
        </el-row>
    </div>
</template>
<script>
import mixin from "@/assets/js/mixin";
export default {
    name: "CurrencyAssets",
    mixins: [mixin],
    data() {
        return {
            xjbInfo: {}
        };
    },
    computed: {
        canRedemption() {
            // 可用份额大于0时才能取现
            return Number(this.xjbInfo.availablevol) > 0;
        }
    },
    created() {
        this.getXjbInfo();
    },
    methods: {
        // 获取现金宝信息
        getXjbInfo() {
            this.$util.request("xjb/query/asset").then((res) => {
                if (res.data) {
                    this.xjbInfo = res.data[0];
                }
            });
        },
        formatCurrencyAnnualRate(rate) {
            // 现金宝七日年化按产品口径固定展示3位小数，避免复用通用金额/涨跌幅精度。
            if (rate === "" || rate === null || rate === undefined) {
                return "--";
            }
            return this.$util.fmtNum(rate, 3) + "%";
        },
        goPersonalBuyBusiness(routeName, businessName) {
            if (this.$util.checkPersonalBuyBusinessDisabled(businessName)) return;
            this.$router.push({ name: routeName });
        }
    }
};
</script>
<style lang="scss">
.bizcomp-currency-assets {
    .cur-info-box {
        background-color: $bg5;
    }
}
</style>
